<!--English Version-->
<section *ngIf="language === 'en'">
    <div class="container-fluid">
        <h2>Batch {{'MEMBER' | translate:patientLabel}}s Import & Enroll to a Channel</h2>
        <br>
        <p>
            The <strong>{{'MEMBER' | translate:patientLabel}}s Import</strong> utility on the System Setting screen
            allows you to perform a bulk
            import of {{'MEMBER' | translate:patientLabel}}s and optionally enroll to a Channel.
            To use this feature, you will need to create a CSV file with {{'MEMBER' | translate:patientLabel}}s' data.
            The CSV file should have a header row with the following columns, and each subsequent row contains data for
            a {{'MEMBER' | translate:patientLabel}}.
        </p>
        <p>
            You may use Excel or any other spreadsheet application to edit the CSV file, but be aware of the auto
            formatting behavior of your application. For example, Excel will automatically trim leading zeros in
            numerical columns, and reformat the date column to your locale. When saving the CSV file, make sure to save
            it as a plain-text CSV file.
        </p>
        <p>Refer to <a target="_blank" href="{{document360Url}}" title="Document360">Document360</a> for more
            details on file
            format.&nbsp;<a href="{{sampleFileUrl}}" download title="Download this template as a file">Download file
                sample
                <i class="fas fa-download fa-lg ml-1"></i>
            </a>
        </p>
    </div>
</section>
<!--Spanish Version-->
<section *ngIf="language === 'es'">
    <div class="container-fluid">
        <h2>Importación e inscripción masiva de {{'MEMBER' | translate:patientLabel}}s a un Channel</h2>
        <br>
        <p>
            La utilidad de importación de {{'MEMBER' | translate:patientLabel}}s en la pantalla de configuración del
            sistema te permite una importación masiva de {{'MEMBER' | translate:patientLabel}}s y, opcionalmente,
            inscribirlos en un Channel.
            Para usar esta funcionalodad necesitarás crear un archivo CSV con los datos de {{'MEMBER' |
            translate:patientLabel}}s.
            El archivo CSV deberá tener una cabecera con las siguientes columnas, y cada fila contendrá los datos de un
            {{'MEMBER' | translate:patientLabel}}.
        </p>
        <p>
            Podrá usar Excel o cualquier aplicación de hojas de cálculo para editar el archivo CSV, pero deberá prestar
            atención del formateo automático que pueda tener su aplicación. Por ejemplo, Excel eliminará todos los ceros
            a la izquierda en las columnas numéricas, así como reformatear la columna de la fecha a tu formato local.
            Cuando grabe el archivo CSV, asegúrese de grabarlo como un archivo CSV de texto plano.
        </p>
        <p>Consulte <a target="_blank" href="{{document360Url}}" title="Document360">Document360</a> para
            obtener más detalles
            sobre el formato de archivo.&nbsp;<a href="{{sampleFileUrl}}" download
                title="Descargue esta plantilla como archivo">Descargar archivo de muestra
                <i class="fas fa-download fa-lg ml-1"></i>
            </a>
        </p>
    </div>
</section>
<!--German Version - TODO-->
<section *ngIf="language === 'de'">
    <div class="container-fluid">
        <h2>Batch {{'MEMBER' | translate:patientLabel}}s Import & Enroll to a Channel</h2>
        <br>
        <p>
            The <strong>{{'MEMBER' | translate:patientLabel}}s Import</strong> utility on the System Setting screen
            allows you to perform a bulk
            import of {{'MEMBER' | translate:patientLabel}}s and optionally enroll to a Channel.
            To use this feature, you will need to create a CSV file with {{'MEMBER' | translate:patientLabel}}s' data.
            The CSV file should have a header row with the following columns, and each subsequent row contains data for
            a {{'MEMBER' | translate:patientLabel}}.
        </p>
        <p>
            You may use Excel or any other spreadsheet application to edit the CSV file, but be aware of the auto
            formatting behavior of your application. For example, Excel will automatically trim leading zeros in
            numerical columns, and reformat the date column to your locale. When saving the CSV file, make sure to save
            it as a plain-text CSV file.
        </p>
        <p>Refer to <a target="_blank" href="{{document360Url}}" title="Document360">Document360</a> for more
            details on file
            format.&nbsp;<a href="{{sampleFileUrl}}" download title="Download this template as a file">Download file
                sample
                <i class="fas fa-download fa-lg ml-1"></i>
            </a>
        </p>
    </div>
</section>